var utils = require('./../global/utils');
var isEmpty = utils.isEmpty;
var config = require('../global/config');

//webRtc事件绑定
module.exports = function (app) {
    app.prototype.bindRTCEmitter = function(){
      var self = this;
      if (!(window.wbWebRTCSDK && window.wbWebRTCSDK.isSupport)) {
        return;
      }
      if (!(window.RTCEmitter && window.RTCEmitter)) {
        return;
      }
      if (!config['is_show_audio_video']) {
        return;
      }
      var rtcEvents = [];
      var isCaller_audio = false;
      var isCallee_audio = false;
      var caller_info = null;
      var callee_info = null;
      function createFalseNews(events) {
        var falseText = '';
        var audio_refused = false;
        var breakFlag = false;
        var not_answered = false;
        for(var index=0;index<events.length;index++){
          var event = events[index];
          if (!isEmpty(event)) {
            switch(event.pageCode) {
              case 107:
              case 101:
              case 104:
                if (caller_info) {
                  caller_info.call_type = 'audio';
                }
                if (callee_info) {
                  callee_info.call_type = 'audio';
                }
                break;
              default:
                break;
            }
            switch(event.code) {
              case 111:
                isCaller_audio = true;
                break;
              case 122:
                isCallee_audio = true;
                break;
              case 120:
              case 121:
              case 104:
                if (caller_info) {
                  caller_info.call_type = 'audio';
                }
                if (callee_info) {
                  callee_info.call_type = 'audio';
                }
                break;
              case 201:
                falseText = isCaller_audio ? '已取消' : '未接听, 点击回拨';
                not_answered = !isCaller_audio;
                break;
              case 205:
              case 206:
                falseText = '呼叫失败';
                breakFlag = true;
                break;
              case 202:
                falseText = '已拒绝';
                audio_refused = true;
                breakFlag = true;
                break;
              case 207:
                falseText = isCaller_audio ? '对方无应答' : '未接听, 点击回拨';
                not_answered = !isCaller_audio;
                breakFlag = true;
                break;
              default:
                if (!isEmpty(event.callTime) && event.callTime !== '00 : 00') {
                  var callTime = event.callTime.replace(/(\s\s*)|:/g, '');
                  if (!isNaN(callTime) && parseInt(callTime) > 0) {
                    falseText = '通话时长 ' + event.callTime.replace(/(\s\s*)/g, '');
                    breakFlag = true;
                  }
                }
                break;
            }
          }
          if (breakFlag) break;
        }
        rtcEvents = [];
        if (!isEmpty(falseText)) {
          if (isCaller_audio && audio_refused) {
            falseText = '对方' + falseText;
          }
          var nosavemsgs = {};
          var false_msg_key;
          if (isCaller_audio && !isEmpty(caller_info)) {
            false_msg_key = caller_info.user_id + '@' + caller_info.user_source;
            if (!isEmpty(caller_info.shop_id) && !isEmpty(caller_info.shop_source)) {
              false_msg_key += '@@' + caller_info.shop_id + '@' + caller_info.shop_source;
            }
          } else if (isCallee_audio && !isEmpty(callee_info)) {
            false_msg_key = callee_info.user_id + '@' + callee_info.user_source;
            if (!isEmpty(callee_info.shop_id) && !isEmpty(callee_info.shop_source)) {
              false_msg_key += '@@' + callee_info.shop_id + '@' + callee_info.shop_source;
            }
          }
          var biz = self._biz;
          if (!isEmpty(false_msg_key) && !isEmpty(biz)) {
            var me = biz.me();
            var nosavemsg = {
              msg_type: 2,
              show_type: "false_msg",
              content: {
                msg: falseText,
                type: "text"
              },
              is_false_new: true,
              belong_to: me.user_id + '@' + me.user_source
              // kf_id: msg.kf_id,
              // kf_source: msg.kf_source
            }
            if (isCaller_audio) {
              nosavemsg.sender_id = me.user_id;
              nosavemsg.sender_source = me.user_source;
              nosavemsg.to_id = caller_info.user_id;
              nosavemsg.to_source = caller_info.user_source;
              nosavemsg.shop_id = caller_info.shop_id;
              nosavemsg.shop_source = caller_info.shop_source;
              nosavemsg.send_time = new Date().getTime();
              nosavemsg.call_type = caller_info.call_type;
              nosavemsg.not_answered = not_answered;
            } else if (isCallee_audio) {
              nosavemsg.sender_id = callee_info.user_id;
              nosavemsg.sender_source = callee_info.user_source;
              nosavemsg.to_id = me.user_id;
              nosavemsg.to_source = me.user_source;
              nosavemsg.shop_id = callee_info.shop_id;
              nosavemsg.shop_source = callee_info.shop_source;
              nosavemsg.send_time = new Date().getTime();
              nosavemsg.call_type = callee_info.call_type;
              nosavemsg.sender_info = callee_info.sender_info;
              nosavemsg.not_answered = not_answered;
            }
            // if (isCaller_audio) {
              var param = {
                user_id: nosavemsg.sender_id,
                user_source: nosavemsg.sender_source
              }
              var shopKey;
              if (!isEmpty(nosavemsg.shop_id) && !isEmpty(nosavemsg.shop_source)) {
                param.shop_id = nosavemsg.shop_id;
                param.shop_source = nosavemsg.shop_source;
                shopKey = param.shop_id + '@' + param.shop_source;
              }
              biz.getContact([param], function (contactResult) {
                var userKey = param.user_id + '@' + param.user_source;
                if (shopKey)userKey += '@@' + shopKey;
                var contact = contactResult[userKey];
                contact.avatar = (contact && contact.avatar) ? contact.avatar : default_avatar;
                nosavemsg.sender_info = contact;
                if (!isEmpty(param.shop_id) && !isEmpty(param.shop_source)) {
                  nosavemsg.sender_info.shop_id = param.shop_id;
                  nosavemsg.sender_info.shop_source = param.shop_source;
                  nosavemsg.is_shop_mode = true;
                }
                nosavemsgs[false_msg_key] = [nosavemsg];
                biz.triggerEvent('falseNews', nosavemsgs);
              });
            // } else {
            //   nosavemsgs[false_msg_key] = [nosavemsg];
            //   biz.triggerEvent('falseNews', nosavemsgs);
            // }
            //console.log('RTCEmitter falseText', falseText, nosavemsgs);
          }
        }
      }
      function rtcEventsHandle(){
        createFalseNews(rtcEvents.concat());
        caller_info = null;
        callee_info = null;
        isCaller_audio = false;
        isCallee_audio = false;
        rtcEvents = [];
      }
      RTCEmitter.on('callToCallee', function(e){
        isCaller_audio = true;
        isCallee_audio = false;
        if (!isEmpty(e) && !isEmpty(e.data)){
          caller_info = {
            call_type: e.data.call_type,
            shop_id: e.data.shop_id,
            shop_source: e.data.shop_source,
            user_id: e.data.user_id,
            user_source: e.data.user_source,
            sender_info: e.data.sender_info
          }
          console.log('RTCEmitter caller_info', caller_info, e);
        }
      });
      RTCEmitter.on('calleeLoadWebRTC', function(e){
        isCaller_audio = false;
        isCallee_audio = true;
        if (!isEmpty(e) && !isEmpty(e.msgItem) && !isEmpty(e.contact)){
          //var contact= e.contact;
          callee_info = {
            call_type: (e.msgItem.show_type === 'call_audio') ? 'audio' : (e.msgItem.show_type === 'call_video' ? 'video' : ''),
            user_id: e.msgItem.sender_id,
            user_source: e.msgItem.sender_source,
            sender_info: {
              avatar: e.contact.avatar
            }
          }
          if (e.msgItem.to_source === 9999) {
            callee_info.shop_id = e.msgItem.to_id;
            callee_info.shop_source = e.msgItem.to_source;
          }
          console.log('RTCEmitter callee_info', callee_info, e);
        }
      })
      RTCEmitter.on('call_msg', function(e){
        if (!isCaller_audio && !isCallee_audio)return;
        if (!isEmpty(e)) {
          console.log('RTCEmitter call_msg', e);
          switch(e.pageCode) {
            case 107:
            case 101:
            case 104:
              rtcEvents.push(e);
              break;
            default:
              break;
          }
          switch(e.code) {
            case 201:
              rtcEvents.push(e);
              rtcEventsHandle();
              break;
            case 202:
              rtcEvents.push(e);
              rtcEventsHandle();
              break;
            case 207:
              rtcEvents.push(e);
              rtcEventsHandle();
              break;
            case 120:
            case 121:
            case 104:
              rtcEvents.push(e);
              break;
            default:
              if (!isEmpty(e.callTime) && e.callTime !== '00 : 00') {
                var callTime = e.callTime.replace(/(\s\s*)|:/g, '');
                if (!isNaN(callTime) && parseInt(callTime) > 0) {
                  rtcEvents.push(e);
                  rtcEventsHandle();
                }
              }
              break;
          }
        }
      })
    };
  };